import { Component } from "preact";
import socket from "../helper/socket";
import sessionCache from "../helper/session-cache";
import '../style/chat.css';
import MessageItem from "./message-item";
import MessageForm from "./message-form";

export default class Chat extends Component {
    constructor(props) {
        super(props);
        this.onHistoryAddition = (historyItem) => {
            this.setState({
                history: sessionCache.integrateHistoryAddition(historyItem)
            })

            this.scrollBottom();
        }

        socket.on('history_addition', this.onHistoryAddition);

        this.messageListRef = null;
        this.state = {
            history: sessionCache.getHistory(),
        }

        this.scrollBottom();
    }

    componentWillUnmount() {
        socket.off('history_addition', this.onHistoryAddition);
    }

    handleMessageSend(message) {
        socket.sendMessage(message);
    }

    scrollBottom() {
        setTimeout(() => {
            if (this.messageListRef !== null) {
                this.messageListRef.scrollTop = this.messageListRef.scrollHeight;
            }
        });
    }

    render() {
        const listItems = this.state.history.map((val) =>
            <MessageItem isSelf={val.senderType === 0} text={val.msg} />
        );

        return (
            <div className={'chat'}>
                <div ref={ (ref) => this.messageListRef = ref } className={'message-list'}>
                    {listItems}
                </div>
                <div className={'bottom'}>
                    <MessageForm onSubmit={this.handleMessageSend.bind(this)} />
                </div>
            </div>
        )
    }
}